// Angular
import { Component, Input, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import {UtilisateurModel} from '../../../../../core/models/main/utilisateur.model';
import {AuthService} from '../../../../../core/ngrx/main/auth.service';
import {selectSessionUtilisateur} from '../../../../../core/ngrx/main/session/session.reducer';
import {configApp} from '../../../../../core/configapp/config';

@Component({
	selector: 'kt-user-profile3',
	templateUrl: './user-profile3.component.html',
})
export class UserProfile3Component implements OnInit {
	// Public properties
	user$: Observable<UtilisateurModel>;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	urlEspaceDistributeur: string= configApp.urlEspaceDistributeur;


	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>,
				private authService: AuthService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(selectSessionUtilisateur));
	}

	/**
	 * Log out
	 */
	logout() {
		//this.store.dispatch(new Logout());
		this.authService.logout();
	}
}
